import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import CollectionDetailView from "./CollectionDetailView";

export default function CollectionDetailScreen() {
  const { collectionId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({ name: "", description: "", properties: [] });

  useEffect(() => {
    if (!collectionId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    axiosInstanceAuth
      .get(`/collection/${collectionId}`)
      .then((res) => {
        const raw = res?.data?.data ?? res?.data;
        const name = raw?.name ?? "";
        const propsRaw = raw?.properties ?? raw?.items ?? (Array.isArray(raw) ? raw : []);
        setData({
          name,
          description: raw?.description ?? "",
          properties: Array.isArray(propsRaw) ? propsRaw : [],
        });
      })
      .catch(() => {
        setData({ name: "", description: "", properties: [] });
      })
      .finally(() => setLoading(false));
  }, [collectionId]);

  const handleBack = () => {
    navigate("/collections");
  };

  return (
    <div className="bg-[#F3F6F9] min-h-screen">
      <div className="container mx-auto">
        <CollectionDetailView
          collectionName={data.name}
          description={data.description}
          properties={data.properties}
          onBack={handleBack}
          isLoading={loading}
        />
      </div>
    </div>
  );
}
